import { REQUEST_LEGAL_DECLRATION_REL } from './constants'

export const requestLegalDeclarationLink = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_LEGAL_DECLRATION_REL)[0]

export const getRiskData = (state) => state.riskData

export const getPriceData = (state) => state.price
